import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export const PASSWORD_RE = /^(?=.*[A-Za-z])(?=.*\d).{10,128}$/;
export const PASSWORD_HINT = "10 caractères minimum, avec au moins une lettre et un chiffre.";

export function ChangePassword() {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (!PASSWORD_RE.test(form.next)) return setErr(PASSWORD_HINT);
    if (form.next !== form.confirm) return setErr("Les deux nouveaux mots de passe ne correspondent pas.");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      localStorage.setItem("gw_token", data.token);
      setForm({ current: "", next: "", confirm: "" });
      toast.success("Mot de passe modifié — vos autres sessions ont été déconnectées");
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="panel p-5 mb-8" data-testid="change-password-panel">
      <div className="flex items-center gap-2 mb-1"><ShieldCheck size={16} className="text-amber-400" /><div className="eyebrow">Sécurité — mot de passe</div></div>
      <p className="text-xs text-zinc-400 mb-4">Changer votre mot de passe déconnecte immédiatement toutes vos autres sessions.</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="space-y-1.5"><Label>Mot de passe actuel</Label><Input type="password" required autoComplete="current-password" maxLength={128} value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })} data-testid="chpwd-current-input" /></div>
        <div className="space-y-1.5"><Label>Nouveau mot de passe</Label><Input type="password" required autoComplete="new-password" minLength={10} maxLength={128} value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })} data-testid="chpwd-new-input" /></div>
        <div className="space-y-1.5"><Label>Confirmer</Label><Input type="password" required autoComplete="new-password" minLength={10} maxLength={128} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="chpwd-confirm-input" /></div>
      </div>
      <p className="text-xs text-zinc-500 mt-3">{PASSWORD_HINT}</p>
      {err && <p className="text-sm text-red-400 mt-2" data-testid="chpwd-error">{err}</p>}
      <Button type="submit" disabled={busy} className="mt-4 bg-amber-500 hover:bg-amber-400 text-zinc-950 font-semibold" data-testid="chpwd-submit-button">{busy ? "Enregistrement…" : "Changer le mot de passe"}</Button>
    </form>
  );
}
